import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded'
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core'
import { advancedColors } from '../theme'

type Props = {
  attributes: DraggableAttributes
  listeners: DraggableSyntheticListeners
  label: string
}

const DragHandle = ({ attributes, listeners, label }: Props) => (
  <Tooltip title={label}>
    <IconButton
      size="small"
      aria-label={label}
      sx={{ color: advancedColors.inkFaint, cursor: 'grab', touchAction: 'none' }}
      {...attributes}
      {...listeners}
    >
      <DragIndicatorRoundedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
)

export default DragHandle
